// Full-screen mobile form shell — used by every V4 add/edit flow so
// forms never crowd the top of a list view. Mirrors the look already
// used by ScheduleMobile/SquadsMobile (sticky header with back arrow +
// title, scrollable body, sticky footer for actions).
//
// Usage:
//   {isV4 && showForm ? (
//     <MobileFormPage
//       title={editingId ? "Edit Team" : "New Team"}
//       onBack={cancelForm}
//       footer={
//         <>
//           <button className="mfp-btn mfp-btn--ghost" onClick={cancelForm}>Cancel</button>
//           <button className="mfp-btn mfp-btn--primary" onClick={save}>Save</button>
//         </>
//       }
//     >
//       {formFields}
//     </MobileFormPage>
//   ) : null}

import React from "react";
import { ArrowLeft } from "lucide-react";

export default function MobileFormPage({
  title,
  onBack,
  footer,
  children,
  headerRight,        // optional extra element in the header (e.g., a delete btn)
}) {
  return (
    <div className="mfp">
      <header className="mfp-head">
        <button
          type="button"
          className="mfp-back"
          onClick={onBack}
          aria-label="Back"
        >
          <ArrowLeft size={18}/>
        </button>
        <h1>{title}</h1>
        {headerRight ? <div className="mfp-head-right">{headerRight}</div> : null}
      </header>

      <div className="mfp-body">
        {children}
      </div>

      {footer ? <div className="mfp-actions">{footer}</div> : null}
    </div>
  );
}
